import React from 'react'

function Certifications() {
  return (
    <div className='mt-5 text-white-50'>
        <h2>Certifications</h2>
        <p>List of my certifications here</p>
        <p className='text-center'>Development in progress...</p>
    </div>
  )
}

export default Certifications